import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliImballoListPage.vue?vue&type=template&id=e2294f16"
import script from "./ConfigurazioniMagazzinoArticoliImballoListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliImballoListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports